<template>
  <div
    class="media-list-entry"
    :class="{
      'edit-mode': this.editMode,
    }"
  >
    <div v-if="editMode" class="delete-button-column">
      <v-icon size="48" @click="$emit('delete-entry')">mdi-delete</v-icon>
    </div>

    <div class="poster-column">
      <work-poster :src="posterSource" :workId="workId" :medium="medium" :width="100"></work-poster>
    </div>

    <div class="details">
      <div class="title">
        <router-link :to="{ name: 'work', params: { medium, workId } }">
          <span v-if="computedPosition !== undefined">{{ computedPosition }}. </span>
          {{ title }}
        </router-link>
      </div>
      <div v-if="releaseDate" class="date">{{ formatDate(releaseDate) }}</div>
      <div v-if="displayMedium" class="medium">{{ userFriendlyMediumWord(medium) }}</div>
    </div>

    <div class="utility-column" v-if="userWorkRelationships && !editMode">
      <work-interaction-utility-button
        :icon-size="24"
        :work-id="workId"
        :medium="medium"
        :user-work-relationships="userWorkRelationships"
        @change-engaged="$emit('change-engaged', $event)"
        @change-saved-for-later="$emit('change-saved-for-later', $event)"
      ></work-interaction-utility-button>
    </div>

    <div class="handle" v-if="editMode">
      <v-icon size="48">mdi-drag</v-icon>
    </div>
  </div>
</template>

<script>
import WorkInteractionUtilityButton from "./work-interaction-utility-button.vue";
import WorkPoster from "./work-poster.vue";

import { formatDate } from "../util/dateHelpers";
import getAspectRatio from "../util/getAspectRatio";
import { userFriendlyMediumWord } from "../util/mediumHelpers";

export default {
  name: "media-list-entry",
  props: {
    workId: String,
    medium: String,
    title: String,
    posterSource: String,
    releaseDate: String,
    userWorkRelationships: Object,
    position: Number,
    index: Number,
    displayMedium: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WorkInteractionUtilityButton,
    WorkPoster,
  },

  computed: {
    computedPosition() {
      if (this.position === undefined) {
        return undefined;
      }
      if (this.editMode) {
        return this.index + 1;
      }
      return this.position;
    },
  },

  methods: {
    formatDate,
    getAspectRatio,
    userFriendlyMediumWord,
  },
};
</script>

<style>
.media-list-entry {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 8px 8px;

  padding: 12px 0;
}

.media-list-entry.edit-mode {
  grid-template-columns: max-content max-content 1fr;
}

.delete-button-column {
  grid-row: 1 / span 1;
  grid-column: span 1;

  display: flex;
  justify-content: center;
  align-items: center;
}

.poster-column {
  grid-row: 1 / span 1;
  grid-column: auto / span 1;
}
.poster {
  border-radius: 5px;
}

.details {
  grid-row: 1 / span 1;
  grid-column: auto / span 1;

  text-align: start;
}
.title {
  font-weight: bold;
}
.media-list-entry .title a {
  color: var(--v-text-base);
}
.date .medium {
  color: var(--v-text-lighten1);
  font-size: 14px;
}

.utility-column {
  grid-row: 1 / span 1;
  grid-column: span 1;
}

.handle {
  grid-row: 1 / span 1;
  grid-column: span 1;

  display: flex;
  justify-content: center;
  align-items: center;
}
.handle:hover {
  cursor: grab;
}
</style>
